
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import i18n from './lang'
import md5 from 'js-md5';
import './permission' // permission control
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"

Vue.prototype.$md5 = md5;
// 全局样式
import Element from 'element-ui'
import './styles/element-variables.scss'

// echarts 组件

import dragVerify from 'vue-drag-verify2'
import '@/styles/index.scss' // global css
import '@/assets/css/style.css'
Vue.config.productionTip = false
Vue.use(Element)
Vue.use(dragVerify)
Vue.component('ImagePreview', ImagePreview)


new Vue({
  i18n,
  render: h => h(App),
  router
}).$mount('#app')
